import { useAuth, useQuestionnaire } from '@/store';
import { ResolveValue } from '@/utils';
export const useResolveValue = () => {
    const { mapComputedValues, state: { cachedQueryAnswers, current, nowOverride, questionnaire } } = useQuestionnaire();
    const { state: { currentUserPhaseSegment } } = useAuth();
    const resolveValue = new ResolveValue(current.state.answers, cachedQueryAnswers, currentUserPhaseSegment, questionnaire.resolvers, mapComputedValues, nowOverride);
    return [resolveValue, {}];
};
export default useResolveValue;
